import './App.css';
import './PageMarketingV2PresentLarge.css';

import { Button } from 'primereact/button';
import Totem2 from './Totem2';
import { useNavigate } from 'react-router-dom';

function PageMarketingV2PresentLarge({ creativeURL }) {
    const navigate = useNavigate();

    return (
        <div style={{ marginTop: '6em', marginBottom: '2em' }}>
            <div className='mk2-present-large'>
                <Totem2
                    creativeURL={creativeURL}
                />
                <div>
                    <div className='mk2-present-large-title'>
                        Ad Screens
                    </div>
                    <div
                        className='mk2-present-large-subtitle'
                    >
                        Starting from
                    </div>
                    <div
                        className='mk2-present-large-price'
                    >
                        9.9 EUR / month
                    </div>
                    <div
                        className='mk2-present-large-subtitle'
                    >
                        In a mission of making advertising <br></br>affordable for everyone.
                    </div>
                    <div className='mk2-present-large-buttons-desktop'>
                        <div className='mk2-present-large-buttons'>
                            <Button
                                label="Prices"
                                severity="success"
                                outlined
                                style={{ margin: '0.2em', cursor: 'pointer' }}
                                size='small'
                                onClick={
                                    () => {
                                        navigate('/v2/pricing');
                                    }
                                }
                            />
                            <Button
                                label="Gallery"
                                severity="secondary"
                                outlined
                                style={{ margin: '0.2em' }}
                                size='small'
                                onClick={
                                    () => navigate('/gallery')
                                }
                            />
                        </div>
                    </div>
                    <div className='mk2-present-large-buttons-mobile'>
                        <div className='mk2-present-large-buttons'>
                            <Button
                                label="Prices"
                                severity="success"
                                outlined
                                style={{ marginRight: '0.4em' }}
                                size='small'
                                onClick={
                                    () => {
                                        navigate('/v2/pricing');
                                    }
                                }
                            />
                            <Button
                                label="Gallery"
                                severity="secondary"
                                outlined
                                size='small'
                                onClick={
                                    () => navigate('/gallery')
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default PageMarketingV2PresentLarge;